import { Link, useNavigate } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/', anchor: '' },
    { name: '平台优势', path: '/', anchor: 'advantages' },
    { name: '服务类目', path: '/', anchor: 'services' },
    { name: '数字权益', path: '/', anchor: 'digital-benefits' },
    { name: '合作伙伴', path: '/', anchor: 'partners' },
    { name: '解决方案', path: '/', anchor: 'solutions' },
    { name: '关于我们', path: '/', anchor: 'about' },
    { name: '联系我们', path: '/contact', anchor: '' }
  ],
  cities: [
    '北京', '上海', '广州', '深圳', '成都', '重庆', '杭州', '南京',
    '武汉', '西安', '天津', '苏州', '郑州', '长沙', '沈阳', '青岛'
  ]
};

export default function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (e: React.MouseEvent, item: typeof footerLinks.navigation[0]) => {
    e.preventDefault();
    if (item.path === '/contact') {
      navigate('/contact');
      return;
    }
    if (!item.anchor) {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(item.anchor);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }, 400);
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* 上部分 */}
      <div className="container mx-auto px-5 lg:px-10 py-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 品牌列 */}
          <div className="space-y-4">
            <img
              src="https://static.readdy.ai/image/5f9cc22383cc9e7cc67ed543cf57b925/c0eeee1c67bbb9492f644f58ac3e6b4f.png"
              alt="工福通"
              className="h-10"
            />
            <p className="text-gray-400 text-xs leading-relaxed">
              数字化员工福利平台<br />
              让企业福利发放更简单<br />
              员工消费更便捷
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-box-line text-base"></i>
              </div>
            </div>
          </div>

          {/* 导航列 */}
          <div>
            <h4 className="text-sm font-bold mb-4">快速导航</h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.anchor ? `#${link.anchor}` : link.path}
                    onClick={(e) => handleNavClick(e, link)}
                    className="text-gray-400 hover:text-orange-500 transition-colors text-xs cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系列 */}
          <div>
            <h4 className="text-sm font-bold mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-orange-500 text-base"></i>
                <div>
                  <p className="text-xs text-gray-500">客服热线</p>
                  <a href="tel:18059252092" className="text-orange-500 font-bold text-base hover:text-orange-400 transition-colors">
                    18059252092
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-orange-500 text-base"></i>
                <div>
                  <p className="text-xs text-gray-500">业务邮箱</p>
                  <a href="mailto:chengqiuxiang@casgrain.cn" className="text-gray-300 text-xs hover:text-orange-500 transition-colors">
                    chengqiuxiang@casgrain.cn
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line text-orange-500 text-base mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-500">工作时间</p>
                  <p className="text-gray-300 text-xs">周一至周日 7:00-19:00</p>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-orange-500 text-base mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-500">公司地址</p>
                  <p className="text-gray-300 text-xs leading-relaxed">福建省厦门市集美区集美大道1799号<br />中国科学院城环所5号楼</p>
                </div>
              </li>
            </ul>
          </div>

          {/* 资质列 */}
          <div>
            <h4 className="text-sm font-bold mb-4">企业资质</h4>
            <div className="space-y-2">
              <div className="bg-white/5 rounded-lg p-2.5 hover:bg-white/10 transition-colors cursor-pointer">
                <p className="text-xs text-gray-300">银联授权服务商</p>
              </div>
              <div className="bg-white/5 rounded-lg p-2.5 hover:bg-white/10 transition-colors cursor-pointer">
                <p className="text-xs text-gray-300">软件著作权 20+项</p>
              </div>
              <div className="bg-white/5 rounded-lg p-2.5 hover:bg-white/10 transition-colors cursor-pointer">
                <p className="text-xs text-gray-300">ISO质量认证</p>
              </div>
              <div className="bg-white/5 rounded-lg p-2.5 hover:bg-white/10 transition-colors cursor-pointer">
                <p className="text-xs text-gray-300">信息安全等级保护</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 中部分 - 服务网络 */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-5 lg:px-10 py-6">
          <h4 className="text-xs text-gray-500 mb-3 text-center">全国服务网络 · 覆盖300+核心城市</h4>
          <div className="flex flex-wrap justify-center gap-2">
            {footerLinks.cities.map((city) => (
              <span
                key={city}
                className="px-3 py-1.5 bg-white/5 rounded-full text-gray-400 text-xs hover:bg-orange-500 hover:text-white transition-all duration-300 cursor-pointer"
              >
                {city}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 下部分 */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-5 lg:px-10 py-4">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 text-xs text-gray-500">
            <p>©2025 中科云粮工福通 版权所有 &nbsp;|&nbsp; 闽ICP备17002812号-3</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
